import type { GroupResource, UserResource } from 'entities/document/model';
import { v4 as uuid } from 'uuid';

export const convertParticipantUserToParticipantGroup = (
  participant: UserResource,
): GroupResource<any> => ({
  id: uuid(),
  isNew: true,
  type: 'participant-group',
  parameters: {
    name: '',
    requiredApprovals: 1,
    participants: [participant],
  },
});
